<template>
  <div class="container-2xl mx-auto max-h-screen overflow-hidden text-secondary text-left box-border">
    <router-view/>
  </div>
</template>